import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=31d425e2&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=31d425e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d425e2",
  null
  
)

export default component.exports